module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gdCjn"))).then(() => parcelRequire('2KbAe'));